import { Grid, makeStyles } from 'beam'
import { FC } from 'react'

const useStyles = makeStyles(theme => ({
  standardBody: {
    alignItems: 'stretch',
    padding: theme.spacing(2),
    width: '100%',
    '& div:first-child': {
      borderTop: '0',
    },
  },
  bodyNoPadding: {
    alignItems: 'stretch',
    height: '100%',
    width: '100%',
    '& div:first-child': {
      borderTop: '0',
    },
  },
}))

export interface BodyProps {
  bodyPadding?: boolean,
}

const Body: FC<BodyProps> = ({ children, bodyPadding = true }) => {
  const classes = useStyles()
  return (
    <Grid container className={bodyPadding ? classes.standardBody : classes.bodyNoPadding}>
      {children}
    </Grid>
  )
}

export default Body
